import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=7459d4e7"
import script from "./Transfers.js?vue&type=script&lang=js&external"
export * from "./Transfers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports